import React, { useEffect, useState } from "react";
import { QuestionBox, CostView, Stepper } from "./styled";
import { Row, Col, Steps, Image, Layout } from 'antd';
import { questionData } from "../../utils";
import Question from "../Questions";
import Result from "../Result";
import 'antd/dist/antd.css';

const phoneImg = require("../../assets/images/mobile.png");
const { Step } = Steps;

const Container = () => {
  const [step, setStep] = useState(0);
  const [isLast, setIsLast] = useState(false);
  const [isFirst, setIsFirst] = useState(true);
  const [showResult, setShowResult] = useState(false);
  const [totalHours, setTotalHours] = useState(0);
  const [hoursData, setHoursData]: any = useState({});
  const [appType, setAppType] = useState(0);
  const [formData, setFormData]: any = useState({});

  useEffect(() => {
    if (step === 0) {
      setIsFirst(true);
    }else {
      setIsFirst(false);
    }

    if (step === questionData.length - 1) {
      setIsLast(true);
    }else if (step === questionData.length) {
      setShowResult(true);
    }else {
      setIsLast(false);
    }
  }, [step]);

  const updateHours = (hours: number, id: any) => {
    if (step === 0) {
      setAppType(id);
    }

    let hoursObj = {...hoursData};
    hoursObj[step] = hours;
    setHoursData(hoursObj);
    let newHours = calculate(hoursObj);
    setTotalHours(newHours);
    setStep(step+1);
  }

  const calculate = (hoursObj: object) => {
    let hours = 0;
    Object.values(hoursObj).forEach((data: any)=> {
      hours = hours + data;
    });
    return hours;
  }

  const onChange = (value: any) => {
    setStep(value);
  };

  const calculateHours = (hours: number) => {
    let newHours  = totalHours + hours;
    setTotalHours(newHours);
    setStep(step+1);
  }

  const handlePrev = () => {
    setStep(step-1);
  }

  const allSteps = questionData.map((data: any) => <Step key={data.id} />)

  return (
    <Layout>
      { showResult ? 
        <Result cost={totalHours*30} hours={totalHours} data={formData} />
      :
        <Row>
          <Col span={17} style={{height: '100vh', overflow: 'auto'}}>
            <Stepper current={step} onChange={onChange} style={{width: '100%', padding: '10px 30px'}}>
              {allSteps}
            </Stepper>
            <QuestionBox>
              <Question
                data={questionData[step]} 
                updateHours={updateHours} 
                isLast={isLast}
                isFirst={isFirst}
                calculateHours={calculateHours} 
                appType={appType}
                handlePrev={handlePrev}
                formData={formData}
                setFormData={setFormData}
              />
              <div style={{display: 'flex', width: '20%'}}>
                <CostView>Total Hours: {totalHours}</CostView>
              </div>
            </QuestionBox>
            
          </Col>
          <Col span={7} style={{height: '100vh', paddingTop: '100px', textAlign: 'center', background: 'white', boxShadow: '4px 0px 10px #302f2f'}}>
            <Image src={phoneImg} style={{width: '240px'}} />
          </Col>
        </Row>
      }
    </Layout>
  )
}

export default Container;